import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const Graph1 = () => {
  const [graphData, setGraphData] = useState([]);

  useEffect(() => {
    fetch(`${API}/graph1`)
      .then(res => res.json())
      .then(data => setGraphData(data))
      .catch(err => console.error('Erreur chargement Graph1 :', err));
  }, []);

  const moisLabels = [
    'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
    'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'
  ];

  const labels = graphData.map(row => moisLabels[row.mois - 1]);

  const commandesLivrees = graphData.map(row =>
    row["Nombre de commande livrées"] === 0 ? null : row["Nombre de commande livrées"]
  );

  const commandesALivrer = graphData.map(row =>
    row["Nombre de commande à livrer"] === 0 ? null : row["Nombre de commande à livrer"]
  );

  const data = {
    labels,
    datasets: [
      {
        label: 'Livrées',
        data: commandesLivrees,
        backgroundColor: 'rgba(187, 241, 192, 0.75)',
        borderColor: '#04202d',
        borderWidth: 0,
        borderRadius: 4,
        stack: 'stack1',
      },
      {
        label: 'À livrer',
        data: commandesALivrer,
        backgroundColor: 'rgba(56, 189, 248, 0.65)',
        borderColor: '#38bdf8',
        borderWidth: 0,
        borderRadius: 4,
        stack: 'stack1',
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'COMMANDES CLIENTS',
        color: '#04202d',
        font: { family: "'IBM Plex Mono', monospace", size: 20, weight: '500' },
        padding: { bottom: 16 },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: '#ffffff',
        borderColor: '#f0ece2',
        borderWidth: 0,
        titleColor: '#04202d',
        bodyColor: '#8b7b64',
        titleFont: { family: "'IBM Plex Mono', monospace", size: 20 },
        bodyFont: { family: "'IBM Plex Sans', sans-serif", size: 20 },
        padding: 10,
      },
      legend: {
        position: 'bottom',
        labels: {
          color: '#8b7b64',
          font: { family: "'IBM Plex Sans', sans-serif", size: 11 },
          boxWidth: 12,
          boxHeight: 12,
          padding: 16,
        }
      }
    },
    scales: {
      x: {
        stacked: true,
        grid: { color: '#f5f1eb', drawBorder: false },
        ticks: { color: '#8b7b64', font: { family: "'IBM Plex Mono', monospace", size: 10 } },
        border: { color: '#f0ece2' },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: { color: '#f5f1eb', drawBorder: false },
        ticks: { color: '#8b7b64', font: { family: "'IBM Plex Mono', monospace", size: 10 } },
        border: { color: '#f0ece2' },
      }
    }
  };

  return (
    <div style={{
      background: '#ffffff',
      border: '1px solid #f0ece2',
      borderRadius: '14px',
      padding: '20px 24px',
      boxShadow: '0 2px 12px rgba(148, 99, 46, 0.06)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0,
        height: '3px',
        borderRadius: '14px 14px 0 0',
      }} />
      <Bar data={data} options={options} height={400} width={750} />
    </div>
  );
};

export default Graph1;